/**
 * 추천 장소 고르기 — 모임 수정/예정 모임에서 sub_place 추천 흐름.
 *
 * 모임 생성 step3 의 PlaceExplore 와 동일한 UX 를 사용하지만 별도 라우트(/meeting/sub-place-recommend)
 * 로 진입해 step 인디케이터·"이 장소로 모임 만들기" 같은 생성 흐름 잔재를 보지 않게 한다.
 *
 * SubPlaceModal 에서 navigate 시 location.state.subPlaceMode = true 가 항상 전달되지만,
 * 새로고침/딥링크 등으로 state 가 비어 있는 경우에도 안전하게 강제한다.
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { PlaceExplore } from './create/PlaceExplore';

export const SubPlaceRecommend = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.state?.subPlaceMode) {
            navigate(location.pathname, {
                replace: true,
                state: { ...(location.state || {}), subPlaceMode: true },
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <PlaceExplore />;
};

export default SubPlaceRecommend;
